// extracted by mini-css-extract-plugin
export default {"examCard":"styles__examCard___bSy2l","highlight":"styles__highlight___KLhvw","titleBlock":"styles__titleBlock___OHWJj","link":"styles__link___BYqCl","title":"styles__title___UZMIu"};